import { defineComponent } from 'vue';
import SelectSpace from '@/entities/space/select-space.vue';
import LoginService from '@/account/login.service';
import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';

import EntitiesMenu from '@/entities/entities-menu.vue';

export default defineComponent({
  components: {
    'entities-menu': EntitiesMenu,
    'select-space': SelectSpace,
  },
  inject: ['loginService', 'translationService', 'accountService', 'alertService'],
  data() {
    return {
      currentLanguage: this.$store.getters.currentLanguage,
      languages: this.$store.getters.languages as any,
      hasAnyAuthorityValues: {} as any,
    };
  },
  computed: {
    authenticated(): boolean {
      return this.$store.getters.authenticated;
    },
    openAPIEnabled(): boolean {
      return this.$store.getters.activeProfiles.indexOf('api-docs') > -1;
    },
    inProduction(): boolean {
      return this.$store.getters.activeProfiles.indexOf('prod') > -1;
    },
  },
  created() {
    const currentLanguage = Object.keys(this.languages).includes(navigator.language) ? navigator.language : this.currentLanguage;
    (this.translationService as () => TranslationService)().refreshTranslation(currentLanguage);
  },
  methods: {
    subIsActive(input: any) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    changeLanguage(newLanguage: string): void {
      (this.translationService as () => TranslationService)().refreshTranslation(newLanguage);
    },
    isActiveLanguage(key: string): boolean {
      return key === this.$store.getters.currentLanguage;
    },
    logout(): Promise<any> {
      localStorage.removeItem('jhi-authenticationToken');
      sessionStorage.removeItem('jhi-authenticationToken');
      this.$store.commit('logout');
      if (this.$route.path !== '/') {
        return this.$router.push('/');
      }
      return Promise.resolve(this.$router.currentRoute.value);
    },
    openLogin(): void {
      (this.loginService as () => LoginService)().openLogin();
    },
    hasAnyAuthority(authorities: any): boolean {
      (this.accountService as () => AccountService)()
        .hasAnyAuthorityAndCheckAuth(authorities)
        .then(value => {
          if (this.hasAnyAuthorityValues[authorities] !== value) {
            this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
          }
        });
      return this.hasAnyAuthorityValues[authorities] ?? false;
    },
    spaceLink(path: string): string {
      const spaceId = (this.$store.getters.space as any)?.id;
      return `/space/${spaceId ?? 'none'}/${path}`;
    },
  },
});
